// store.js
import { reactive } from 'vue'

export const store = reactive({
  facebookUrl: 'https://www.facebook.com/britishairwaysband',
  bandManagerEmail: 'britishairwaysband@gmail.com'
})